export default {
  name: 'marking--orderReport',
  urlParamName: 'marking--orderReport',
};
